import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create(() => ({
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
}));
